import React from 'react';

import TextInput, { TextInputProps } from 'components/curo-components/common/TextInput';
import { NOT_CYRILLIC_REGEX, formatString } from 'utils/curo-helpers/validation';

type EmailInputProps = Omit<TextInputProps, 'formatter'>;

const EmailInput = ({ ...props }: EmailInputProps) => {
  return <TextInput formatter={formatString(NOT_CYRILLIC_REGEX)} {...props} />;
};

export default EmailInput;
